import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/chevron-down-filled.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M10.3858 15.4858L6.21426 11.3142C4.95433 10.0543 5.84667 7.90002 7.62848 7.90003L15.9716 7.90003C17.7534 7.90003 18.6458 10.0543 17.3858 11.3142L13.2143 15.4858C12.4332 16.2669 11.1669 16.2669 10.3858 15.4858Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ChevronDownFilledIcon };
